import { createContext } from "react";

export interface AtsIntegration {
  api_key: string;
  customer_group_id: string;
  report_url_type: string;
  require_authorised_user: boolean;
}

export interface GreenhouseIntegrationContextType {
  atsIntegrationData: AtsIntegration;
  setAtsIntegration: (atsIntegrationData: AtsIntegration) => void;
}

export const GreenhouseIntegrationContext =
  createContext<GreenhouseIntegrationContextType>({
    atsIntegrationData: {
      api_key: "",
      customer_group_id: "",
      report_url_type: "DIRECT_PDF_URL",
      require_authorised_user: true,
    },
    setAtsIntegration: (newState: AtsIntegration) => newState,
  });
